module.exports = __webpack_public_path__ + "static/img/module-title.e6c465a6.png";